var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAessvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#231E54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.015 69.4728L21.3448 64.2062C20.9116 63.5874 20.8845 62.7714 21.2756 62.1258L36.3868 37.0811H44.7502L52.2201 49.9307H59.4222L55.788 56.3122H47.8729L40.4241 43.2175L25.015 69.4728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7978 62.9595L40.2105 49.8887L44.3501 56.6677L40.2105 63.3361H59.7802V67.6552L63.7032 69.2514H37.1028L32.7978 62.9595Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6521 37.0811L52.2201 43.7286H59.7351C59.7351 43.7286 60.2916 39.2541 64.7742 37.0811H48.6521Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0618 59.1275V66.7405C61.0618 66.7405 65.6586 69.3857 72.933 69.3857C80.2073 69.3857 85.9203 66.2323 85.9203 59.9824C85.824 47.9248 67.2621 52.5846 66.7627 44.6518C66.7627 41.2025 70.3157 40.4075 73.288 40.4075C76.2603 40.4075 80.5533 41.896 80.5533 46.5767H84.1453V39.6961C84.1453 39.6961 80.4329 37 72.7886 37C65.1442 37 61.0588 40.9455 61.0588 45.8235C60.6526 57.2265 79.4943 53.4962 79.8132 60.8342C79.8132 62.9953 79.1333 65.9095 72.6081 65.9095C66.0828 65.9095 64.6839 62.0029 64.6839 59.2082L61.0588 59.1275H61.0618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAessvg);
export default __webpack_public_path__ + "static/media/aessvg.b9195490d964af5f4ca28fbee3e07932.svg";
export { ForwardRef as ReactComponent };